import { render, staticRenderFns } from "./ElectricityIndexForm.vue?vue&type=template&id=2c0f7af7"
import script from "./ElectricityIndexForm.vue?vue&type=script&lang=js"
export * from "./ElectricityIndexForm.vue?vue&type=script&lang=js"
import style0 from "./ElectricityIndexForm.vue?vue&type=style&index=0&id=2c0f7af7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports